import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'agencies',
  inputShow: gql`
    query agencies($input: AgencyQueryInput) {
      agencies(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Agencies',
    group: 'Facilities',
    order: 1,
  },
};
